export const unAuthorizedErrorMessage = 'Access denied! You need to be authorized to perform this action!';

export const congitoChallenges = {
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  MISSING_NAME_ATTRIBUTE: 'MISSING_NAME_ATTRIBUTE',
};
